module.exports = __webpack_public_path__ + "img/6_clean_water_and_sanitation_color.4940dd68.svg";